import { Box } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import useStyles from "./styles";

// The main purpose is to add the minimum height throughout the portal
type ContentProps = {
    children: JSX.Element | JSX.Element[];
    className?: string;
};

function Content({ children, className }: ContentProps): JSX.Element {
    const classes = useStyles();
    const rootClasses = clsx(classes.root, className);
    return (
        <Box test-data-id="content-box" className={rootClasses}>
            {children}
        </Box>
    );
}

export { Content };
